export default {
    formatter(format) {
        const args = Array.prototype.slice.call(arguments, 1);
        return format.replace(/{(\d+|\w+)}/g, function(match, numKey) {
            return typeof args[numKey] !== 'undefined' ? args[numKey] : match;
        });
    },

    reverse(string) {
        return (string === '') ? '' : this.reverse(string.substr(1)) + string.charAt(0);
    }
};



// WEBPACK FOOTER //
// ./src/util/string_utils.js